//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "@/observable/store";
import { FactoryUtils } from "@/utils/FactoryUtils";
import Txrweb from "@/utils/mixin/mixinTxrweb";

export default {
  name: "quota",
  mixins: [Txrweb],
  data() {
    return {
      uuid: "",
      statusFlag: true,
      timer: null,
      text: {},
      code: "--",
      isPayFlag: "",
      payText: "领取成功",
      timeDelayer: null,
      codeNumber:''
    };
  },

  computed: {
    refid() {
      return store.refid;
    },
    templateFlag() {
      return this.$route.query.templateFlag || "zh_tw";
    },
  },
  created() {
    window.scrollTo(0, 0);
    
  },
  mounted() {
    this.codeNumber = this.$route.query.codeNumber
    if (this.codeNumber == "75") {
      this.payText = "请勿重复领取";
      this.STATISTICS("load", "sybao_ins_repeat_page");
    } else if (this.codeNumber == "70") {
      this.payText = "支付成功";
      this.STATISTICS_CONFIG.insur_pay_success_page()
      this.finishTX(this.stopTX);
    } else {
      // this.STATISTICS("load", "sybao_ins_pay_success_page");
      this.STATISTICS_CONFIG.insur_receive_success_page()
      if(this.templateFlag != 'coupon'){ //coupon为卡券领取 不需要录入视频
        this.receiveTX(this.stopTX);
      }
    }
    this.$nextTick(()=>{
      document.title = this.payText;
    })

  },
  beforeDestroy() {
    window.clearInterval(this.timer);
    this.timer = null;
    // if (this.stopTX) {
    //   this.stopTX()
    // }
  },

  methods: {
    subscribe() {
      this.$router.replace({
        path: "/coupon",
        query: {
          templateFlag: this.templateFlag,
        },
      });
    },
  },
};
